export enum OwnershipType {
  Unknown = 0,
  Private = 1,
  State = 2,
  County = 3,
  Municipal = 4,
  HousingCooperative = 5,
  Other = 6,
}
